import { z } from 'zod';

import { schemaConsorsAccountNumber } from './accountNumber.schema';
import { schemaConsorsBic } from './bic.schema';
import { schemaConsorsBlz } from './blz.schema';
import { schemaConsorsDateYYYYMM } from './date-yyyy-mm.schema';
import { schemaConsorsIban } from './iban.schema';
import { schemaConsorsSubscriberEnum } from './subscriberEnum.schema';

export const schemaConsorsBankAccount = z
    .object({
        accountNumber: schemaConsorsAccountNumber.optional(),
        accountOwner: schemaConsorsSubscriberEnum.optional(),
        accountSince: schemaConsorsDateYYYYMM,
        bic: schemaConsorsBic.optional(),
        blz: schemaConsorsBlz.optional(),
        iban: schemaConsorsIban.optional(),
    })
    .refine(
        (data) => {
            if (data.iban === undefined) return true;
            if (!data.iban.startsWith('DE') && data.bic === undefined) return false;
            return true;
        },
        { message: 'bic is required when iban does not start with DE' },
    )
    .refine(
        (data) => {
            if (!data.iban && (data.accountNumber === undefined || data.blz === undefined)) return false;
            return true;
        },
        { message: 'when iban is empty, account number and blz are required' },
    );

export type SchemaConsorsBankAccount = z.infer<typeof schemaConsorsBankAccount>;
